import { useAuthContext } from '../../../auth/contexts/AuthContext';
import useGraphQLClient from '../../../../app/hooks/useGraphQLClient';
import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import AppError from '../../../../app/features/error/services/AppError';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import IFundAssetSG from '../../interfaces/fund/IFundAssetSG';

const useInvestmentAssetFundSG = (fundId: number | null) => {
	const auth = useAuthContext();
	const graphQLClient = useGraphQLClient();
	const { i18n } = useTranslation();
	const filter = {
		fundId: fundId,
		userId: auth.authOverrideUserId,
	};

	const { data, isFetching } = useQuery<IFundAssetSG, Error>(
		['investmentAssetFundSG', filter, i18n.language],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query ($fundId: Int) {
							investmentAssetFundSG(fundId: $fundId) {
								valuationDate
								assetsFund {
									name
									country
									businessSector
									assetType
									weightInFund
								}
							}
						}
					`,
					filter,
				)) as { investmentAssetFundSG: IFundAssetSG };
				return data.investmentAssetFundSG;
			} catch (e) {
				throw new AppError(e, 'useInvestmentAssetFundSG');
			}
		},
		{
			enabled:
				!!filter.fundId && auth.currentCompany !== null && auth.isInvestor === true && auth.isAuthenticated,
		},
	);

	return {
		isFetching,
		fundAssets: data,
	};
};

export default useInvestmentAssetFundSG;
